// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import Header from "../../components/common/Header";
// import { X } from "lucide-react";

// const Lightbox = ({ image, title, onClose }) => {

//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, []);

//   return (
//     <div
//       className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
//       onClick={onClose}
//     >
//       <button
//         onClick={onClose}
//         className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
//       >
//         <X className="w-8 h-8" />
//       </button>
//       <div
//         className="max-w-7xl max-h-full"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <img
//           src={image}
//           alt={title}
//           className="max-w-full max-h-[90vh] object-contain mx-auto"
//         />
//         <p className="text-white text-center mt-4 text-lg">{title}</p>
//       </div>
//     </div>
//   );
// };

// const Events = () => {
//   const [expandedEvent, setExpandedEvent] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [fullscreenImage, setFullscreenImage] = useState(null);
//   const [fullscreenTitle, setFullscreenTitle] = useState("");

//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/events/get-all`
//         );
//         const result = await response.json();

//         if (result.success) {
//           setEvents(result.data);

//           if (result.data.length > 0) {
//             setExpandedEvent(result.data[0]._id);
//           }
//         } else {
//           setError("Failed to load events");
//         }
//       } catch (err) {
//         setError("Error connecting to server");
//         console.error("Error fetching events:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEvents();
//   }, []);

//   const toggleEvent = (eventId) => {
//     setExpandedEvent(expandedEvent === eventId ? null : eventId);
//   };

//   const EventSkeleton = () => (
//     <div className="bg-white rounded-3xl shadow-2xl overflow-hidden p-8 animate-pulse">
//       <div className="flex items-center justify-between">
//         <div className="h-8 bg-gray-200 rounded w-1/3"></div>
//         <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-rose-50 via-purple-50 to-blue-50">
//       <Header
//         breadcrumbs={[
//           { label: "HOME", path: "/" },
//           { label: "EVENTS", path: "/events" },
//         ]}
//         title="Fashion Events"
//       />

//       <div className="px-4 sm:px-6 lg:px-8 py-10">
//         {loading && (
//           <div className="space-y-6">
//             {[1, 2, 3].map((i) => (
//               <EventSkeleton key={i} />
//             ))}
//           </div>
//         )}

//         {error && !loading && (
//           <div className="bg-red-50 border border-red-200 p-4 rounded-lg text-center">
//             <p className="text-red-600 font-medium">{error}</p>
//           </div>
//         )}

//         {/* Events List */}
//         {!loading && !error && events.length > 0 && (
//           <div className="space-y-6">
//             {events.map((event, index) => (
//               <motion.div
//                 key={event._id}
//                 className="bg-white rounded-3xl shadow-2xl overflow-hidden"
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//               >
//                 {/* Event Header */}
//                 <div
//                   className="px-8 py-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
//                   onClick={() => toggleEvent(event._id)}
//                 >
//                   <div className="flex items-center justify-between">
//                     <h2 className="text-3xl font-bold text-gray-900">
//                       {event.title}
//                     </h2>
//                     <motion.div
//                       animate={{
//                         rotate: expandedEvent === event._id ? 180 : 0,
//                       }}
//                       transition={{ duration: 0.3 }}
//                       className="w-10 h-10 bg-gradient-to-r from-red-700 to-blue-700 rounded-full flex items-center justify-center text-white shadow-lg"
//                     >
//                       ↓
//                     </motion.div>
//                   </div>
//                 </div>

//                 {/* Expanded Content */}
//                 {expandedEvent === event._id && (
//                   <motion.div
//                     initial={{ opacity: 0, height: 0 }}
//                     animate={{ opacity: 1, height: "auto" }}
//                     exit={{ opacity: 0, height: 0 }}
//                     transition={{ duration: 0.5 }}
//                     className="border-t border-gray-100"
//                   >
//                     {/* Images Grid */}
//                     {event.images && event.images.length > 0 && (
//                       <div className="px-8 pb-6">
//                         <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
//                           {event.images.map((image, imgIndex) => (
//                             <motion.div
//                               key={imgIndex}
//                               className="relative overflow-hidden rounded-xl aspect-square cursor-pointer"
//                               whileHover={{ scale: 1.05 }}
//                               transition={{ duration: 0.3 }}
//                               onClick={() => {
//                                 setFullscreenImage(image);
//                                 setFullscreenTitle(event.title);
//                               }}
//                             >
//                               <img
//                                 src={image}
//                                 alt={`${event.title} ${imgIndex + 1}`}
//                                 className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//                               />
//                               <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end justify-center">
//                                 <p className="text-white text-sm mb-2 font-semibold">
//                                   View Image
//                                 </p>
//                               </div>
//                             </motion.div>
//                           ))}
//                         </div>
//                       </div>
//                     )}
//                   </motion.div>
//                 )}
//               </motion.div>
//             ))}
//           </div>
//         )}
//       </div>

//       {fullscreenImage && (
//         <Lightbox
//           image={fullscreenImage}
//           title={fullscreenTitle}
//           onClose={() => {
//             setFullscreenImage(null);
//             setFullscreenTitle("");
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default Events;

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../../components/common/Header";
import { X, Play, Sparkles } from "lucide-react";
import { ChevronDown, ChevronUp } from "lucide-react";

const Lightbox = ({ media, title, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
      >
        <X className="w-8 h-8" />
      </button>
      <div className="w-full max-h-full" onClick={(e) => e.stopPropagation()}>
        {media.type === "video" ? (
          <video
            src={media.url}
            controls
            autoPlay
            className="max-w-full max-h-[90vh] mx-auto"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={media.url}
            alt={title}
            className="max-w-full max-h-[90vh] object-contain mx-auto"
          />
        )}
        {media.name && (
          <p className="text-white text-center mt-4 text-lg font-semibold">
            {media.name}
          </p>
        )}
      </div>
    </div>
  );
};

const Events = () => {
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fullscreenMedia, setFullscreenMedia] = useState(null);
  const [fullscreenTitle, setFullscreenTitle] = useState("");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/events/get-all`
        );
        const result = await response.json();

        if (result.success) {
          setEvents(result.data);

          if (result.data.length > 0) {
            setExpandedEvent(result.data[0]._id);
          }
        } else {
          setError("Failed to load events");
        }
      } catch (err) {
        setError("Error connecting to server");
        console.error("Error fetching events:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const toggleEvent = (eventId) => {
    setExpandedEvent(expandedEvent === eventId ? null : eventId);
  };

  const EventSkeleton = () => (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden p-8 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-8 bg-gray-200 rounded w-1/3"></div>
        <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-purple-50 to-blue-50">
      <Header
        breadcrumbs={[
          { label: "HOME", path: "/" },
          { label: "EVENTS", path: "/events" },
        ]}
        title="Fashion Events"
      />

      <div className="px-4 sm:px-6 lg:px-8 py-10">
        {loading && (
          <div className="space-y-6">
            {[1, 2, 3].map((i) => (
              <EventSkeleton key={i} />
            ))}
          </div>
        )}

        {error && !loading && (
          <div className="bg-red-50 border border-red-200 p-4 rounded-lg text-center">
            <p className="text-red-600 font-medium">{error}</p>
          </div>
        )}

        {/* Events List */}
        {!loading && !error && events.length > 0 && (
          <div className="space-y-6">
            {[...events].reverse().map((event, index) => (
              <motion.div
                key={event._id}
                className="bg-white rounded-3xl shadow-2xl overflow-hidden"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                {/* Event Header */}
                <div
                  className="px-8 py-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                  onClick={() => toggleEvent(event._id)}
                >
                  <div className="flex items-center justify-between">
                    <h2 className="text-3xl font-bold text-gray-900 heading">
                      {event.eventName}
                    </h2>
                    <motion.div
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      animate={{
                        rotate: expandedEvent === event._id ? 180 : 0,
                        background:
                          expandedEvent === event._id
                            ? "linear-gradient(to right, #2563eb, #b91c2c)"
                            : "linear-gradient(to right, #b91c1c, #1e3a8a)",
                      }}
                      transition={{ duration: 0.4 }}
                      className="w-10 h-10 rounded-full flex items-center justify-center text-white shadow-lg cursor-pointer"
                    >
                      {expandedEvent === event._id ? (
                        <ChevronUp className="w-6 h-6" />
                      ) : (
                        <ChevronDown className="w-6 h-6" />
                      )}
                    </motion.div>
                  </div>
                </div>

                {/* Expanded Content */}
                {expandedEvent === event._id && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.5 }}
                    className="border-t border-gray-100"
                  >
                    {/* Media with Captions - Alternating Layout */}
                    {event.media && event.media.length > 0 && (
                      <div className="px-8 py-8 space-y-6">
                        {[...event.media]
                          .reverse()
                          .map((mediaItem, mediaIndex) => (
                            <div
                              key={mediaItem._id || mediaIndex}
                              className={`flex flex-col ${
                                mediaIndex % 2 === 0
                                  ? "md:flex-row"
                                  : "md:flex-row-reverse"
                              } gap-8 items-start`}
                            >
                              {/* Media */}
                              <div className="w-full md:w-2/5">
                                <motion.div
                                  className="relative overflow-hidden rounded-2xl shadow-xl cursor-pointer group bg-gray-100"
                                  whileHover={{ scale: 1.03 }}
                                  transition={{ duration: 0.3 }}
                                  onClick={() => {
                                    setFullscreenMedia(mediaItem);
                                    setFullscreenTitle(event.eventName);
                                  }}
                                >
                                  {mediaItem.type === "video" ? (
                                    <>
                                      <video
                                        src={mediaItem.url}
                                        className="w-full h-96 object-cover"
                                        muted
                                        loop
                                        playsInline
                                      />
                                      <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                                        <div className="bg-white bg-opacity-95 rounded-full p-4 transform transition-transform duration-300 group-hover:scale-110 shadow-2xl">
                                          <Play
                                            className="w-10 h-10 text-red-700"
                                            fill="currentColor"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <img
                                      src={mediaItem.url}
                                      alt={
                                        mediaItem.name ||
                                        `${event.eventName} ${mediaIndex + 1}`
                                      }
                                      className="w-full h-96 object-contain"
                                    />
                                  )}
                                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                                    <p className="text-white text-sm font-semibold tracking-wide">
                                      {mediaItem.type === "video"
                                        ? "▶ Play Video"
                                        : "🔍 View Full Size"}
                                    </p>
                                  </div>
                                </motion.div>
                              </div>

                              {/* Media Name and Captions */}
                              <div className="w-full md:w-3/5 space-y-6">
                                {/* Media Name - Featured */}
                                {mediaItem.name && (
                                  <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                    className="relative"
                                  >
                                    <div className="bg-gradient-to-r from-red-700 via-purple-700 to-blue-700 p-[2px] rounded-2xl shadow-lg">
                                      <div className="bg-white rounded-2xl p-5">
                                        <div className="flex items-start gap-3">
                                          <div className="flex-shrink-0 mt-1">
                                            <Sparkles className="w-6 h-6 text-red-700" />
                                          </div>
                                          <h3 className="text-xl font-bold text-gray-900 leading-relaxed flex-1 heading">
                                            {mediaItem.name}
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </motion.div>
                                )}

                                {/* Captions */}
                                {mediaItem.captions &&
                                mediaItem.captions.length > 0 ? (
                                  <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.3 }}
                                    className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl shadow-md border border-gray-100"
                                  >
                                    <div className="space-y-4">
                                      {mediaItem?.captions?.map(
                                        (caption, captionIndex) => (
                                          <div
                                            key={captionIndex}
                                            className="flex items-start gap-3"
                                          >
                                            <div className="flex-shrink-0 w-2 h-2 bg-gradient-to-r from-red-700 to-blue-700 rounded-full mt-2"></div>
                                            <p className="text-gray-700 text-base leading-relaxed flex-1 sub-heading">
                                              {caption}
                                            </p>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </motion.div>
                                ) : (
                                  !mediaItem.name && (
                                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200">
                                      <p className="text-gray-400 italic text-center">
                                        No captions available for this media
                                      </p>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>
        )}

        {/* No Events Found */}
        {!loading && !error && events.length === 0 && (
          <div className="bg-white rounded-3xl shadow-2xl p-12 text-center">
            <div className="text-6xl mb-4">📅</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              No Events Found
            </h3>
            <p className="text-gray-600">
              Check back later for upcoming fashion events
            </p>
          </div>
        )}
      </div>

      {fullscreenMedia && (
        <Lightbox
          media={fullscreenMedia}
          title={fullscreenTitle}
          onClose={() => {
            setFullscreenMedia(null);
            setFullscreenTitle("");
          }}
        />
      )}
    </div>
  );
};

export default Events;
